import zh from './zh.js'
import en from './en.js'
import vn from './vn.js'
import ph from './ph.js'

export default { zh, en, vn, ph }
